/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingAccountData
 */
export interface BillingAccountData {
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    companyRegistrationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAccountData
     */
    vatNumber?: string | null;
    /**
     * 
     * @type {BillingAccountDataCountryCodeEnum}
     * @memberof BillingAccountData
     */
    countryCode?: BillingAccountDataCountryCodeEnum;
}


/**
 * @export
 */
export const BillingAccountDataCountryCodeEnum = {
    Cz: 'CZ',
    Sk: 'SK'
} as const;
export type BillingAccountDataCountryCodeEnum = typeof BillingAccountDataCountryCodeEnum[keyof typeof BillingAccountDataCountryCodeEnum];


/**
 * Check if a given object implements the BillingAccountData interface.
 */
export function instanceOfBillingAccountData(value: object): value is BillingAccountData {
    return true;
}

export function BillingAccountDataFromJSON(json: any): BillingAccountData {
    return BillingAccountDataFromJSONTyped(json, false);
}

export function BillingAccountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingAccountData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'street': json['street'] === undefined ? undefined : json['street'] === null ? null : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'email': json['email'] == null ? undefined : json['email'],
        'companyRegistrationNumber': json['companyRegistrationNumber'] === undefined ? undefined : json['companyRegistrationNumber'] === null ? null : json['companyRegistrationNumber'],
        'vatNumber': json['vatNumber'] === undefined ? undefined : json['vatNumber'] === null ? null : json['vatNumber'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function BillingAccountDataToJSON(json: any): BillingAccountData {
    return BillingAccountDataToJSONTyped(json, false);
}

export function BillingAccountDataToJSONTyped(value?: BillingAccountData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'street': value['street'],
        'city': value['city'],
        'zip': value['zip'],
        'email': value['email'],
        'companyRegistrationNumber': value['companyRegistrationNumber'],
        'vatNumber': value['vatNumber'],
        'countryCode': value['countryCode'],
    };
}

